<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Vouchers</h1>
          </div>
          <!-- aaa -->
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button icon-right="plus" type="is-primary" @click="dialog = true"
            disabled
              >Adicionar</b-button
            >
          </div>

          <div class="level-item">
            <b-button
              icon-right="cloud-download-alt"
              type="is-info"
              @click="importUsers"
              disabled
              >Download</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <div class="card-header"></div>

      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
      >
        <template slot-scope="props">
          <b-table-column
            field="code"
            label="Código"
            :style="props.row.cpf ? 'text-decoration: line-through' : ''"
          >
            {{ props.row.code }}
          </b-table-column>

          <b-table-column field="dataCriacao" label="Data de Criação">
            {{ new Date(props.row.dataCriacao).toLocaleDateString("pt-BR") }}
          </b-table-column>
          <b-table-column field="type" label="Tipo">{{
            props.row.type
          }}</b-table-column>
          <b-table-column field="validade" label="Validade">{{
            props.row.validade
          }}</b-table-column>
          <b-table-column label="Disponibilidade">
            <span>{{ props.row.cpf ? "Em uso" : "Livre" }}</span>
          </b-table-column>
          <b-table-column label="Capacidade">
            {{
              props.row.type == "Individual" ? props.row.numDispositivos : "-"
            }}
          </b-table-column>
          <b-table-column field="actions" label="Actions">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-light"
              @click="editItem(props.row)"
              disabled
              >Editar</b-button
            >
            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              disabled
              >Excluir</b-button
            >
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem vouchers para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="dialog"
      has-modal-card
      trap-focus
      :can-cancel="false"
      aria-role="dialog"
      aria-modal
    >
      <form action="">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Novo Voucher</p>
          </header>
          <section class="modal-card-body">
            <b-field
              label="Voucher"
              label-position="on-border"
              type="is-primary"
              message="# - alfanuméricos, A - letras, 9 - números, '-' - separador"
            >
              <b-input v-model="editedItem.format" required> </b-input>
            </b-field>

            <b-field>
              <div class="columns is-multiline">
                <div class="column is-half">
                  <b-field
                    type="is-primary"
                    label="Tipo"
                    label-position="on-border"
                  >
                    <b-select
                      v-model="editedItem.type"
                      :disabled="isEdited"
                      expanded
                    >
                      <option
                        v-for="option in itemsTipo"
                        :value="option"
                        :key="option"
                      >
                        {{ option }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-half">
                  <b-field
                    type="is-primary"
                    label="Validade"
                    label-position="on-border"
                  >
                    <b-input
                      v-model.number="editedItem.validade"
                      expanded
                      suffix="horas"
                    >
                    </b-input>
                    <p class="control is-primary">
                      <span class="button is-static">horas</span>
                    </p>
                  </b-field>
                </div>
                <div
                  class="column is-half"
                  v-if="editedItem.type == 'Individual' && !isEdited"
                >
                  <b-field
                    type="is-primary"
                    label="Quantidade"
                    label-position="on-border"
                  >
                    <b-input v-model="editedItem.qtd"></b-input>
                  </b-field>
                </div>
                <div
                  class="column is-half"
                  v-if="editedItem.type == 'Individual'"
                >
                  <b-field
                    type="is-primary"
                    label=" N.º Dispositivos"
                    label-position="on-border"
                  >
                    <b-input
                      v-model.number="editedItem.numDispositivos"
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="close">
              Cancelar
            </b-button>
            <b-button type="is-primary" @click.native="save">
              Salvar
            </b-button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import qrcode from "qrcode-generator-es6";
import axios from "axios";
import sms_credentials from "../../static/sms_credentials.json";

var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;

const ws = new Webservices();

export default {
  data: () => ({
    perPage: 10,
    snackbar: false,
    snackbarText: "SMS enviado com sucesso",
    phones: "",
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: "dataCriacao",
      descending: true,
      totalItems: 0
    },
    desserts: [],
    quantidadeVoucher: 1,
    itemsTipo: ["Geral", "Individual"],
    items: ["Uma vez", "Durante a validade"],
    dialog: false,
    headers: [
      {
        text: "Code",
        align: "left",
        value: "text",
        sortable: false
      },
      { text: "Data de criação", align: "left", sortable: true },
      {
        text: "Tipo",
        align: "left",
        value: "text",
        sortable: false
      },
      {
        text: "Validade",
        align: "left",
        value: "text"
      },
      {
        text: "Disponibilidade",
        value: "disponibilidade",
        sortable: true,
        align: "left"
      },
      {
        text: "Capacidade",
        value: "numDispositivos",
        sortable: true,
        align: "left"
      },
      { text: "Actions", align: "left", value: "name", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    },
    defaultItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      code: 0,
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    }
  }),
  computed: {
    ...mapGetters(["getRules", "getID"]),
    formTitle() {
      return this.editedIndex == -1 ? "Novo Voucher" : "Editar Voucher";
    },
    isEdited() {
      return this.editedIndex != -1;
    },
    formOkLabel() {
      return this.editedIndex == -1 ? "Criar" : "Atualizar";
    }
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    ws.getVouchers("5cee92f937e31001d76e445a").then(res => {
      this.desserts = res.data;
    });
  },

  watch: {
    dialog(val) {
      if (val) {
        store.state.currentModal = "addOrEditVoucherModal";
      } else {
        store.state.currentModal = undefined;
        this.close();
      }
    },
    getID(newValue) {
      this.desserts = [];

      ws.getVouchers(newValue).then(res => {
        this.desserts = res.data;
      });
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    getClientName() {
      if (store.state.client) {
        return store.state.client.name;
      } else {
        return "";
      }
    },
    sendSms(voucher) {
      var self = this;
      var url = sms_credentials.url;
      var access_token = sms_credentials.access_token;
      var sender = sms_credentials.Sender;

      var phonesList = this.phones.replace(/\-|\ |\./gi, "");

      var fullUrl = url + "/api/v2/send?auth-key=" + access_token;

      var body = {
        Sender: sender,
        Receivers: phonesList,
        Content: "Voucher para acesso ao Wi-Fi: " + voucher.item.code
      };

      var xmlhttp = new XMLHttpRequest(); // new HttpRequest instance

      xmlhttp.addEventListener("readystatechange", function() {
        if (this.readyState === this.DONE) {
          self.phones = "";

          self.addSnackMessage("Sucesso! Voucher enviado");

          voucher.expanded = false;
        }
      });

      xmlhttp.open("POST", fullUrl);

      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );

      xmlhttp.send(JSON.stringify(body));
    },
    addSnackMessage(msg) {
      this.snackbarText = msg;
      this.snackbar = true;
    },
    initialize() {},
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = item;
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Você tem certeza que deseja remover essa voucher?")) {
        ws.deleteVoucher(item.id).then(res => {
          if (res.data.count == 1) {
            const index = this.desserts.indexOf(item);
            this.desserts.splice(index, 1);
          }
        });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.close();

      if (this.editedIndex > -1) {
        ws.updateVoucher(this.editedItem).then(res => {
          this.editedIndex = -1;
        });
      } else {
        var alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var numericos = "0123456789";
        var alphanumericos = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        var quantidade = this.editedItem.qtd;

        for (var i = 0; i < quantidade; i++) {
          var codigo = "";

          for (var j = 0; j < this.editedItem.format.length; j++) {
            var letra = this.editedItem.format.substring(j, j + 1);

            if (letra == "#") {
              var index = Math.floor(Math.random() * 36);
              codigo += alphanumericos.substring(index, index + 1);
            } else if (letra == "A" || letra == "a") {
              var index = Math.floor(Math.random() * 26);
              codigo += alpha.substring(index, index + 1);
            } else if (letra == "9") {
              var index = Math.floor(Math.random() * 10);
              codigo += numericos.substring(index, index + 1);
            } else if (letra == "-") {
              codigo += "-";
            }
          }
          var voucher = Object.assign({}, this.editedItem);
          voucher["code"] = codigo;
          voucher["client_id"] = store.state.client.id;
          delete voucher["qtd"];

          ws.saveVoucher(voucher).then(res => {
            this.desserts.push(res.data);
          });
        }
      }
    },

    gerarVoucher() {},
    importUsers() {
      this.dialogImport = false;

      var fields = [
        "exhibitionType",
        "validade",
        "code",
        "dataCriacao",
        "observacoes"
      ];

      var json2csvParser = new Json2csvParser({ fields });
      var csv = json2csvParser.parse(this.desserts.filter(el => !el.cpf));

      var blob = new Blob([csv], {
        type: "text/csv"
      });

      FileSaver.saveAs(blob, "vouchers.csv");
    },

    getQrCode(props) {
      var valor = props.item.code;

      const qr = new qrcode(0, "H");

      qr.addData(valor);
      qr.make();
      return qr.createImgTag(6, 2);
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Voucher.vue